/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VariantOption } from './VariantOption';
import {
    VariantOptionFromJSON,
    VariantOptionFromJSONTyped,
    VariantOptionToJSON,
} from './VariantOption';

/**
 * Representation of a Base Option
 * @export
 * @interface BaseOption
 */
export interface BaseOption {
    /**
     * Variant type of base option
     * @type {string}
     * @memberof BaseOption
     */
    variantType?: string;
    /**
     * List of all variant options
     * @type {Array<VariantOption>}
     * @memberof BaseOption
     */
    options?: Array<VariantOption>;
    /**
     * 
     * @type {VariantOption}
     * @memberof BaseOption
     */
    selected?: VariantOption;
}

/**
 * Check if a given object implements the BaseOption interface.
 */
export function instanceOfBaseOption(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BaseOptionFromJSON(json: any): BaseOption {
    return BaseOptionFromJSONTyped(json, false);
}

export function BaseOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'variantType': !exists(json, 'variantType') ? undefined : json['variantType'],
        'options': !exists(json, 'options') ? undefined : ((json['options'] as Array<any>).map(VariantOptionFromJSON)),
        'selected': !exists(json, 'selected') ? undefined : VariantOptionFromJSON(json['selected']),
    };
}

export function BaseOptionToJSON(value?: BaseOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'variantType': value.variantType,
        'options': value.options === undefined ? undefined : ((value.options as Array<any>).map(VariantOptionToJSON)),
        'selected': VariantOptionToJSON(value.selected),
    };
}

